import { z } from 'zod';
import { templateAdvanceLogicV1Schema } from './advance-logic';
import { templateNamedWidgetSchema } from './base';
import { fieldLayoutShape } from './field-layout';
import { templateParameterV1Schema } from './parameter';
import { templateReferenceV1Schema } from './reference';
import { TEXT_COLOR_VALUES, templateTextColorSchema } from './typography';

export const templateInputV1ValidationRules = z.enum([
  'none',
  // text only
  'uppercase',
  'lowercase',
  // number only
  'positive',
  'negative',
  'decimalPoint',
]);

export const templateInputV1Type = z.enum([
  'inputText',
  'inputNumber',
  'inputEmail',
]);

export const templateInputSchema = templateNamedWidgetSchema.extend({
  type: templateInputV1Type,
  value: z.string(),
  placeholder: z.string(),
  isRequired: z.boolean(),
  labelColor: templateTextColorSchema.default(TEXT_COLOR_VALUES.BLACK),
  unit: z.string().optional(),
  showUnit: z.boolean().default(false),
  reference: templateReferenceV1Schema,
  validationRule: templateInputV1ValidationRules,
  parameter: templateParameterV1Schema.optional(),
  ...fieldLayoutShape,
  advanceLogics: templateAdvanceLogicV1Schema,
});

export type TemplateInputV1 = z.infer<typeof templateInputSchema>;
